import LegalLayout from "@/components/legal/LegalLayout";

const H2 = ({ children }) => (
  <h2 className="font-display text-3xl md:text-4xl tighter text-white mt-14 mb-5 leading-tight">
    {children}
  </h2>
);
const P = ({ children }) => <p>{children}</p>;
const UL = ({ children }) => (
  <ul className="list-disc pl-6 space-y-2 marker:text-[#FF6B1A]">{children}</ul>
);
const PH = ({ children }) => (
  <span className="font-mono text-[13px] tracking-[0.06em] uppercase text-[#FF6B1A]/90 bg-[#FF6B1A]/10 border border-[#FF6B1A]/25 rounded px-2 py-[3px]">
    {children}
  </span>
);

export default function LegalNotes() {
  return (
    <LegalLayout eyebrow="Note legali" title="Note legali" updated="Gennaio 2026">
      <H2>1. Titolarità del Sito</H2>
      <P>
        Il presente sito web è di proprietà di <strong className="text-white">Delta Pictures S.r.l.</strong>, con sede legale in{" "}
        <strong className="text-white">Via G. Boglietti 2, 13900 Biella</strong>, P.IVA{" "}
        <strong className="text-white">02154000026</strong>, R.E.A. <strong className="text-white">BI 181760</strong>, Capitale Sociale € 50.000 i.v.
      </P>
      <P>
        "Modo Motori" è un progetto editoriale digitale di Delta Pictures S.r.l. dedicato al mondo automotive e alla mobilità.
      </P>

      <H2>2. Contenuti del Sito</H2>
      <P>
        I contenuti pubblicati sul Sito (testi, immagini, grafiche, video, elementi grafici, layout, marchi) sono di proprietà
        del Titolare o dei rispettivi aventi diritto e sono tutelati dalla normativa in materia di diritto d'autore e proprietà
        industriale. È vietata qualsiasi forma di riproduzione, distribuzione, modifica o utilizzo senza espressa autorizzazione
        scritta del Titolare, salvo per uso personale e non commerciale.
      </P>

      <H2>3. Marchi e loghi</H2>
      <P>
        Il marchio "Modo Motori" e il relativo logo, così come tutti i marchi terzi eventualmente riprodotti nel Sito, sono di
        proprietà dei rispettivi titolari e vengono utilizzati esclusivamente per finalità editoriali, informative o di
        collaborazione documentata.
      </P>

      <H2>4. Contenuti automotive di terze parti</H2>
      <P>
        Le case automobilistiche, i modelli, le fotografie e i video eventualmente presenti nel Sito appartengono ai rispettivi
        produttori o autori. La loro presenza non implica un rapporto commerciale con il Titolare, salvo quanto esplicitamente
        indicato nei singoli contenuti come "branded content", "contenuto sponsorizzato" o "in collaborazione con".
      </P>

      <H2>5. Limitazione di responsabilità</H2>
      <P>
        Il Titolare pone la massima cura nella pubblicazione dei contenuti, ma non garantisce l'assenza di errori o inesattezze.
        Il Titolare declina ogni responsabilità per:
      </P>
      <UL>
        <li>eventuali danni diretti o indiretti derivanti dall'accesso o dall'uso del Sito;</li>
        <li>l'utilizzo delle informazioni pubblicate a scopi diversi da quelli meramente informativi;</li>
        <li>i contenuti di siti terzi eventualmente linkati dal Sito, dei quali non condivide né controlla i contenuti.</li>
      </UL>

      <H2>6. Link a siti esterni</H2>
      <P>
        Il Sito può contenere link a risorse esterne (es. canale YouTube ufficiale, profili social, siti partner). Il Titolare
        non è responsabile per i contenuti, le politiche sulla privacy o le pratiche commerciali di tali siti terzi.
      </P>

      <H2>7. Modifiche al Sito</H2>
      <P>
        Il Titolare si riserva il diritto di modificare in qualsiasi momento la struttura, i contenuti e le condizioni di
        accesso al Sito, senza necessità di preavviso.
      </P>

      <H2>8. Legge applicabile e foro competente</H2>
      <P>
        Le presenti Note legali sono regolate dalla legge italiana. Per qualsiasi controversia relativa al Sito e ai suoi
        contenuti sarà competente in via esclusiva il foro di <strong className="text-white">Biella</strong>, salvo il diverso foro inderogabile
        previsto dalla legge a tutela del consumatore.
      </P>

      <H2>9. Contatti</H2>
      <P>
        Per qualsiasi comunicazione relativa al Sito o alle presenti Note legali è possibile scrivere a{" "}
        <a href="mailto:commerciale@modomotori.it" className="text-[#FF6B1A] hover:underline">commerciale@modomotori.it</a>.
      </P>
    </LegalLayout>
  );
}
